module.exports = __webpack_public_path__ + "img/live2.34a3f209.jpg";